import React from 'react';
import {BadgeCheck, KeyRound, ShieldCheck, Signal, Wallet} from 'lucide-react';
import styles from './styles/ProductProofBar.module.css';

interface ProductProofBarProps {
    items: string[];
}

const icons = [Signal, BadgeCheck, ShieldCheck, Wallet, KeyRound];

const ProductProofBar: React.FC<ProductProofBarProps> = ({items}) => {
    return (
        <div className={styles.wrap}>
            {items.map((item, index) => {
                const Icon = icons[index % icons.length];

                return (
                    <article className={`site-card-soft ${styles.item}`} key={item}>
                        <Icon size={16}/>
                        <span>{item}</span>
                    </article>
                );
            })}
        </div>
    );
};

export default ProductProofBar;
